import 'magnific-popup';

//Form Popup
$('.form-trigger').magnificPopup({
	type: 'inline',
	mainClass: 'mfp-form',
	removalDelay: 160,
	fixedContentPos: true,
	closeBtnInside: true
});

// popup form Than you
$('#schedule-popup').on('submit', function(e){
	const $this = $(this);

	e.preventDefault();

	$this.parent().addClass('submited');
})

$('.form--demo input[type="text"], .form--demo input[type="email"]').on('keyup', function(){
	if( $('.form--demo input[type="text"]').val() != 0 && $('.form--demo input[type="email"]').val() != 0 && $('.form--demo option:selected').val() != ''){
		$('.form--demo .form__btn').removeAttr('disabled');
	} else {
		$('.form--demo .form__btn').attr('disabled', 'disabled');
	}
})

$('.form--demo input[type="text"], .form--demo input[type="email"], .form--demo select').on('change', function(){
	if( $('.form--demo input[type="text"]').val() != 0 && $('.form--demo input[type="email"]').val() != 0 && $('.form--demo option:selected').val() != ''){
		$('.form--demo .form__btn').removeAttr('disabled');
	} else {
		$('.form--demo .form__btn').attr('disabled', 'disabled');
	}
})
